// @ts-check

(function () {
  /**
   * @param {string} type
   * @param {string} id
   * @returns {string}
   */
  function buildEmbedUrl(type, id) {
    if (!type || !id) return '';

    if (type === 'youtube') {
      return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    }

    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0';
    }

    return '';
  }

  /**
   * @param {HTMLElement} player
   */
  function startExternalVideo(player) {
    if (!player || player.dataset.loaded === 'true') return;

    var embedTarget = /** @type {HTMLElement | null} */ (player.querySelector('[data-fit-impact-embed]'));
    if (!embedTarget) return;

    var videoType = embedTarget.dataset.videoType || '';
    var videoId = embedTarget.dataset.videoId || '';
    var embedUrl = buildEmbedUrl(videoType, videoId);
    if (!embedUrl) return;

    var iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.title = embedTarget.dataset.videoTitle || 'Video player';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');

    embedTarget.innerHTML = '';
    embedTarget.appendChild(iframe);
    player.dataset.loaded = 'true';
  }

  /**
   * @param {HTMLElement} player
   */
  function startNativeVideo(player) {
    if (!player) return;

    var video = player.querySelector('video');
    if (!video) return;

    try {
      video.currentTime = 0;
    } catch (error) {
      /* no-op */
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* no-op */
      });
    }
  }

  /**
   * @param {HTMLElement} trigger
   */
  function openPlayer(trigger) {
    var card = trigger.closest('[data-fit-impact-card]');
    if (!card) return;

    var preview = /** @type {HTMLElement | null} */ (card.querySelector('[data-fit-impact-preview]'));
    var player = /** @type {HTMLElement | null} */ (card.querySelector('[data-fit-impact-player]'));
    if (!player) return;

    if (preview) {
      preview.classList.add('is-hidden');
    }

    player.hidden = false;
    card.classList.add('is-playing');

    if (player.dataset.videoKind === 'external') {
      startExternalVideo(player);
      return;
    }

    startNativeVideo(player);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest('[data-fit-impact-play]');
    if (!trigger) return;

    event.preventDefault();
    openPlayer(/** @type {HTMLElement} */(trigger));
  });
})();
